var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEbayProductsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".white{fill:#fff;}.ebay{fill:url(#ebay-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ebay-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cbc875"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47403,
    stopColor: "#94c824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#93c822"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009444"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ebay",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M61.1005,33.5757l-18.48678,10.67346,6.79386,3.92232c.36644.21156.8179.21156,1.18434,0l16.11838-9.30558c.7896-.45586.78961-1.59554.00002-2.0514l-5.60981-3.23881Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M38.42148,41.8288l18.4871-10.67333-6.3164-3.64674c-.36645-.21157-.81792-.21156-1.18437,0l-16.11822,9.30586c-.78959.45587-.78958,1.59554.00001,2.0514l5.13187,2.96282Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M47.32819,51.8119l-6.87174-3.96749v9.87964l-4.19211-2.17681v-10.1232l-5.12063-2.95643c-.76735-.44303-1.72654.11075-1.72654.99681v18.68835c0,.41122.21938.7912.57551.99681l16.18448,9.34412c.76735.44303,1.72653-.11076,1.72653-.99681v-18.68818c0-.41122-.21938-.7912-.5755-.99681Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "path2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M66.2801,54.24661c-.14167-4.24111-2.60717-4.39205-5.2422-2.8234-2.84142,1.69151-5.10997,4.86275-5.50736,9.22266l10.74957-6.39926ZM55.45182,63.76766c.19706,4.07954,2.48259,5.20112,5.62521,3.33031,2.17731-1.29616,4.1141-3.57254,4.7626-6.40245l3.76611-2.24198c-.73247,5.3947-4.89335,9.55479-8.47473,11.6868-6.51191,3.87657-9.39794,1.05335-9.39794-5.07093,0-6.74177,2.98507-12.95891,9.45736-16.81189,5.15165-3.0668,8.92629-1.89988,8.92629,5.55165v1.22843l-14.66489,8.73007Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEbayProductsScraper);
export default __webpack_public_path__ + "static/media/ebay-products-scraper.4438155b2dd6abdae7dbbf0fb3871b24.svg";
export { ForwardRef as ReactComponent };